module.exports = __webpack_public_path__ + "static/media/parawebcv_page-0003.6221d942.jpg";